import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { useId } from '../../../internal/hooks';
import { ControlButtonGroup } from '../../../internal/components/ControlButton';
import { RadioButton } from '../RadioButton';
function RadioButtonGroupComponent(props) {
  var options = props.options,
    value = props.value,
    defaultValue = props.defaultValue,
    disabled = props.disabled,
    invalid = props.invalid,
    onChange = props.onChange,
    role = props.role,
    _props$spliced = props.spliced,
    spliced = _props$spliced === void 0 ? true : _props$spliced,
    inline = props.inline,
    size = props.size;
  var isControlled = React.useRef(props.hasOwnProperty('value'));
  var preparedOptions = React.useMemo(function () {
    return options.map(function (option) {
      return _objectSpread(_objectSpread({}, option), {}, {
        onChange: onChange && function (e) {
          return onChange(e, option.value);
        }
      });
    });
  }, [options, onChange]);
  var name = useId(props.name);
  return /*#__PURE__*/React.createElement(ControlButtonGroup, {
    role: role,
    spliced: spliced,
    inline: inline
  }, preparedOptions.map(function (option) {
    var key = String(option.value);
    return /*#__PURE__*/React.createElement(RadioButton, {
      key: key
      // Приводится к строке, чтобы не ослаблять типы
      ,
      name: name,
      value: key,
      checked: isControlled.current ? value === option.value : undefined,
      defaultChecked: defaultValue !== undefined ? defaultValue === option.value : undefined,
      disabled: disabled,
      invalid: invalid,
      label: option.label,
      onChange: option.onChange,
      role: role === 'listbox' ? 'option' : undefined,
      size: size
    });
  }));
}
RadioButtonGroupComponent.defaultProps = {
  spliced: true
};

/**
 * Компонент для работы с RadioButton как с группой
 *
 * ВНИМАНИЕ:
 * При использовании вблизи края станицы может выходить отступом за края, создавая скролл
 * Чтобы этого не было, убедитесь что обертка страницы имеет overflow-x: hidden
 *
 * @export
 * @param {IRadioButtonGroupProps} props
 * @returns
 */
export var RadioButtonGroup = /*#__PURE__*/React.memo(RadioButtonGroupComponent);